import { useField, useFormikContext } from 'formik';

import { TextArea } from '../../InputFields';

import type { InputPropsType } from '@/types/inputTypes';

interface FormikTextAreaProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean | string;
  onChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement>,
    helpers: { setFieldValue: unknown; setFieldError: unknown }
  ) => void;
  InputProps?: InputPropsType;
}

export const FormikTextArea = ({
  name,
  label = '',
  placeholder = '',
  disabled = false,
  onChange,
  InputProps = {},
}: FormikTextAreaProps) => {
  const [field, meta] = useField(name);
  const { values, setFieldValue, setFieldError } = useFormikContext<Record<string, unknown>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFieldValue(name, event.target.value);
    if (onChange) {
      onChange(event, { setFieldValue, setFieldError });
    }
  };

  return (
    <TextArea
      name={field.name}
      value={field.value as string}
      onChange={handleChange}
      onBlur={field.onBlur}
      label={label}
      placeholder={placeholder}
      disabled={isDisabled}
      {...(meta.touched && { supportMessage: meta.error })}
      {...(meta.touched && { helperText: meta.error ? 'error' : 'standard' })}
      InputProps={InputProps}
    />
  );
};
